import { observer } from "mobx-react-lite";

import { useNewWebsiteDomainFormState } from "./form.state";
import { NewWebsiteDomainFormView } from "./form.view";

export const NewWebsiteDomainForm = observer(() => {
  const state = useNewWebsiteDomainFormState();
  return <NewWebsiteDomainFormView state={state} />;
});
